import ControlList from '../../utilities/Control/ControlList'
import { Keys } from './constants'
import { StoragePage } from './types'

export const storagePage: StoragePage = {}

export const controlList = new ControlList(Keys.MAIN, {
    path: '2>/v5.6/apis/shipping_cost_report',
    theads: [
        '#',
        'Declaración',
        'Tipo envío',
        'OC',
        'Proveedor',
        'Almacén',
        'FOB (Local)',
        'FOB (USD)'
    ]
})

controlList.badgeRemove('company_id', false)
